import type { JourneyWithProgress } from '@/features/journeys'

export type SortOption =
  | 'recent'
  | 'mostCompleted'
  | 'leastProgress'
  | 'mostProgress'
  | 'az'
  | 'za'

/**
 * 'recent' sorts by id desc — the API doesn't expose created_at, so higher
 * auto-increment id is used as a recency proxy (see prd.md R.T.1).
 * 'mostCompleted' and 'mostProgress' are aliases of the same comparator:
 * the API has no separate "completion" vs "progress" signal today.
 */
export function sortJourneys(
  journeys: JourneyWithProgress[],
  option: SortOption
): JourneyWithProgress[] {
  const list = [...journeys]

  switch (option) {
    case 'recent':
      return list.sort((a, b) => b.id - a.id)
    case 'mostCompleted':
    case 'mostProgress':
      return list.sort(
        (a, b) => b._progress.finishedPercent - a._progress.finishedPercent
      )
    case 'leastProgress':
      return list.sort(
        (a, b) => a._progress.finishedPercent - b._progress.finishedPercent
      )
    case 'az':
      return list.sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'))
    case 'za':
      return list.sort((a, b) => b.name.localeCompare(a.name, 'pt-BR'))
  }
}
